import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { BookPastDueBehaviour } from "@app/models/enums/book-past-due-behaviour";

@HateoasResource("priorities")
export class Priority extends BaseEntity {
  code: String;
  description: string;
  scoreWeight: number;
  backgroundColor: string;
  foregroundColor: string;
  // add a bookPastDueBehaviour with an enum value of: public enum BookPastDueBehaviour {
  //     DEFAULT,
  //     ALLOW,
  //     DENY
  // }
  bookPastDueBehaviour: BookPastDueBehaviour;
  bookBeforeDueBehaviour: BookPastDueBehaviour;
}
